module.exports = __webpack_public_path__ + "img/image11.59a6915b.jpg";